import saveAs from 'file-saver';
import { ContractInfo, DocumentFormat, FileFormat } from '../types';
import DocumentResource from '../../../resources/DocumentResource';

export const downloadFile = async (
    downloadFormat: FileFormat,
    contractInfo: ContractInfo
) => {
    const { name, uuid, versionUuid, documentUuid, dealType } = contractInfo;

    const documentFormat =
        downloadFormat === FileFormat.DOCX
            ? DocumentFormat.DOCX
            : DocumentFormat.ORIGINAL;

    const document = await DocumentResource.getDocument(
        uuid,
        versionUuid,
        documentUuid,
        dealType,
        documentFormat
    );
    const filenameWithoutExtension = name.includes('.')
        ? name.split('.').slice(0, -1).join('.')
        : name;
    const filename = `${filenameWithoutExtension}.${downloadFormat}`;
    saveAs(document, filename);
};
